const SCROLL_TO_TRAVELER = 'SCROLL_TO_TRAVELER';
const SAVE_TRAVELER_CARD = 'SAVE_TRAVELER_CARD';

export default {
	SCROLL_TO_TRAVELER,
	SAVE_TRAVELER_CARD,
};
